import { FunctionComponent } from "react";
import { Price, SkeletonLoader } from "@kanda-libs/ks-design-library";
import { CLASS_NAMES, PRICE_PROPS, TOTAL_LABEL } from "components/job/JobLayout/JobLineItems/Footer/constants";
import useFooterProps from "components/job/JobLayout/JobLineItems/Footer/useFooterProps";

export interface FooterProps {}

const Footer: FunctionComponent<FooterProps> = function () {
  const { total } = useFooterProps();

  return (
    <div className={CLASS_NAMES.container}>
      <div className={CLASS_NAMES.label}>
        <SkeletonLoader afterLoading={TOTAL_LABEL} />
      </div>
      <Price amount={total} {...PRICE_PROPS} />
    </div>
  );
};

export default Footer;
